import { App } from '@capacitor/app'
App.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack) {
        window.history.back()
    }
    else {
        App.exitApp();
    }
})